import { render } from "./ChallengeChip.vue?vue&type=template&id=3dc0a395"
import script from "./ChallengeChip.vue?vue&type=script&lang=js"
export * from "./ChallengeChip.vue?vue&type=script&lang=js"

import "./ChallengeChip.vue?vue&type=style&index=0&id=3dc0a395&lang=scss"
script.render = render

export default script